import anime from 'animejs';

export default class Spotlight {
  constructor(el) {
    this.el = el
    this.setVars()
    this.bindEvents()
    this.init();
  }

  setVars() {
    this.close = this.el.querySelector('[data-close]');
    this.hideClass = 'hidden';
    this.delay = 3000; // in ms
    this.duration = 220; // in ms
  }
  bindEvents() {
    this.close.addEventListener('click', this.handleClose)
  }
  init() {
    this.revealSpotlight(this.el);
  }

  revealSpotlight(el) {
    el.classList.remove(this.hideClass);
    el.style.opacity = 0;
    this.animateSpotlight(el);
  }

  handleClose = (e) => {
    e.preventDefault();
    this.animateSpotlight(this.el, 'hide');
  }

  animateSpotlight(el, dir = 'show') {
    anime({
      targets: el,
      opacity: () => { return (dir === 'show') ? [0,1] : [1,0]},
      translateY: () => { return (dir === 'show') ? [10,0] : [0,10]},
      delay: () => { return (dir === 'show') ? this.delay : 0},
      easing: 'easeInOutSine',
      duration: this.duration,
      complete: () => {
        if(dir ==='hide') {
          el.classList.add(this.hideClass);
        }
      }
    })
  }
}
